var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightAnswerCell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.114746,
    y: 0.420898,
    width: 85.5488,
    height: 85.5488,
    rx: 9.50542,
    fill: "#098064"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.96631,
    y: 3.27246,
    width: 76.0434,
    height: 76.0434,
    rx: 8.55488,
    fill: "url(#paint0_linear_5001_41931)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.9775 71.9119V11.0772L77.0764 10.0078L73.2742 60.0301C72.799 62.5847 72.6564 66.4938 67.8086 70.4861C63.9084 73.698 27.9845 75.6602 10.1226 77.3775L10.8949 79.3974C28.6779 79.3578 65.5273 79.3024 70.6602 79.3974C75.7932 79.4925 78.5616 74.8229 78.9775 71.9119Z",
    fill: "#E0EBE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5413 43.5307L46.4615 46.5534H33.1159L30.0932 43.5307L33.1159 40.4509H46.4615L49.5413 43.5307ZM50.5108 42.447L47.431 39.3673V24.9951L50.5108 21.9724L53.5335 24.9951V39.3673L50.5108 42.447ZM49.4842 20.9458L46.4045 23.9685H33.1159L30.0361 20.8887L33.0588 17.923H46.4045L49.4842 20.9458ZM28.9525 21.9724L31.9752 24.9951V39.4243L28.9525 42.5041L25.9298 39.4243V24.9381L28.9525 21.9724ZM25.9298 47.58L28.9525 44.5573L31.9752 47.58V62.0662L28.9525 65.089L25.9298 62.0662V47.58ZM47.431 47.58L50.5108 44.5573L53.5335 47.58V62.0662L50.5108 65.089L47.431 62.0662V47.58ZM49.4842 66.1156L46.4045 69.1953H33.1159L30.0932 66.1156L33.1159 63.0928H46.4045L49.4842 66.1156Z",
    fill: "#098064"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5001_41931",
    x1: 13.2329,
    y1: 9.34773,
    x2: 67.5496,
    y2: 84.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAnswerCell);
export default __webpack_public_path__ + "static/media/RightAnswerCell.cd78d46a3df9d9622d5d.svg";
export { ForwardRef as ReactComponent };